module.exports = __webpack_public_path__ + "img/17_37.ecbec344.png";